import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { html } from "@tento-ui/component";
import type { ChatMessage } from "./chat-types";
import { ChatTermTurn } from "./chat-term-turn";
import { CodeBlockPlugin } from "./chat-block-plugin";

// The document register: the same turn, full-width, no chrome — the ChatGPT
// shape. Structurally this IS the terminal turn (the block loop, the height
// reporting, the recycle discipline are inherited unchanged); what differs is
// the reading register, and only two things carry it:
//
//   - assistant text upgrades to markdown, exactly as the bubble does, because
//     a document renders prose as prose — where the terminal turn takes every
//     block at its word;
//   - turns breathe: a paragraph of vertical air below each turn, because a
//     document separates speakers by whitespace where a terminal separates
//     them by glyphs and a messenger by boxes.
@component({ name: "std-chat-plain-turn" })
export class ChatPlainTurn extends ChatTermTurn {
  protected override pluginTypeFor(
    blockType: string,
    message: ChatMessage,
  ): string {
    return message.role !== "user" && blockType === "text"
      ? "markdown"
      : blockType;
  }

  static override $styles: Style.Compat[] = [
    CodeBlockPlugin.$panelStyle,
    css`
      :host {
        display: block;
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
      }

      :host([debug-boundaries]) {
        outline: 1px solid var(--red, red);
        outline-offset: -1px;
      }

      #content {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding-block-end: var(--chat-plain-turn-gap, 16px);
        /* The row's own gutter — the thread never pads horizontally. */
        padding-inline: var(--chat-turn-inset, 0px);
      }
    `,
  ];

  static override $html: Option<HTMLTemplateElement> = html`
    <div id="content"></div>
  `;
}
